const DramaData = [
    { 
        id: 1,
        name: "Tip Shoi",
        img: "https://i.ibb.co/P5YpXyf/Natok1.jpg",
        video: "https://www.youtube.com/embed/vmbPjeO3qBs"
    },
    { 
        id: 2,
        name: "Ochena Prem",
        img: "https://i.ibb.co/M1cxhKV/Natok2.jpg",
        video: "https://www.youtube.com/embed/V8HhHEaoxFA"
    },
    { 
        id: 3,
        name: "Ohongkar",
        img: "https://i.ibb.co/F8RNx11/Natok3.jpg",
        video: "https://www.youtube.com/embed/1Obb4HgLSiE"
    },
    { 
        id: 4,
        name: "Shat dugone chouddo",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/xayvwEu1CmC.jpg",
        video: "https://www.youtube.com/embed/1Obb4HgLSiE"
    },
    { 
        id: 5,
        name: "Vai Vai",
        img: "https://i.ibb.co/1fyVLfD/Natok5.jpg",
        video: "https://www.youtube.com/embed/V8HhHEaoxFA"
    },
    { 
        id: 6,
        name: "Murkho Bou",
        img: "https://i.ibb.co/ZWkK6GY/Natok7.jpg",
        video: "https://www.youtube.com/embed/V8HhHEaoxFA"
    },
    { 
        id: 7,
        name: "Shonir Dosha",
        img: "https://i.ibb.co/gPMpqGS/Natok6.jpg",
        video: "https://www.youtube.com/embed/V8HhHEaoxFA"
    },
    { 
        id: 8,
        name: "Murkho Bou",
        img: "https://i.ibb.co/ZWkK6GY/Natok7.jpg",
        video: "https://www.youtube.com/embed/V8HhHEaoxFA"
    },
    { 
        id: 9,
        name: "Hasir Natok",
        img: "https://i.ibb.co/ss4szsj/Natok8.jpg",
        video: "https://www.youtube.com/embed/V8HhHEaoxFA"
    },
    { 
        id: 10,
        name: "Porinoy",
        img: "https://i.ibb.co/Khvg7xx/Natok9.jpg",
        video: "https://www.youtube.com/embed/V8HhHEaoxFA"
    },
    { 
        id: 11,
        name: "Cigarrete",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/MqxKT2iy54K.jpg",
        video: "https://www.youtube.com/embed/V8HhHEaoxFA"
    },
    { 
        id: 12,
        name: "Rup Kothar Golpo",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/jYbhOO79ox6.jpg",
        video: "https://www.youtube.com/embed/V8HhHEaoxFA"
    },
    { 
        id: 13,
        name: "Mira",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/xayvwEu1CmC.jpg",
        video: "https://www.youtube.com/embed/V8HhHEaoxFA"
    },
    { 
        id: 14,
        name: "Kothar Golpo",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/wana45ux17h.jpg",
        video: "https://www.youtube.com/embed/V8HhHEaoxFA"
    },

];

export default DramaData;